
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gJ7c2QbPlbOU4E5_45PB5sweI7kq6w2lkec3Z5lKRTdVIcMeta } from "/codebuild/output/src2963062645/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexBZS0XPOHabN9ivh3YMekE6E3xTENkA1nnVMrkwSXsxoMeta } from "/codebuild/output/src2963062645/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchWUTOTN7r0_3Z0h1o3_45EUEc7472NQ8DSpwhzvXsWdgloMeta } from "/codebuild/output/src2963062645/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as index1XgNirdurdS_45aKdZq5wPiTcpLOIdAyD3EnC1ZHeORGwMeta } from "/codebuild/output/src2963062645/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93tz_CC1k9er7pfI_45kLOgbm7_OJdxlRS837YYpu2oEEPQMeta } from "/codebuild/output/src2963062645/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as index5RBmuybxVKyfkDmB_WQV38CBSU1mzlUJWpgOowkJnsoMeta } from "/codebuild/output/src2963062645/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93GPUy_45M6OBrxAsMGlkGrN1Z3oxxlQNgYUk26txxsoEhoMeta } from "/codebuild/output/src2963062645/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexQ_45bEeiN61bwTfmqb3GY3kq_o8GkmgV0nR5T_TMMRp_450Meta } from "/codebuild/output/src2963062645/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93TSUA9u0VVtc8j9YUKPzJZT08L9JHvsK4YA_45XALtUgT8Meta } from "/codebuild/output/src2963062645/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as index4m_Whf1CL2LP8Gxa9pD5B89TgWwt0fKNJh97cZP9z6gMeta } from "/codebuild/output/src2963062645/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexpjunPW1qfIg9y5mcnNj88DCiemORFQoD_q2dHGG9XtQMeta } from "/codebuild/output/src2963062645/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src2963062645/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src2963062645/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src2963062645/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src2963062645/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src2963062645/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: index5RBmuybxVKyfkDmB_WQV38CBSU1mzlUJWpgOowkJnsoMeta || {},
    component: () => import("/codebuild/output/src2963062645/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src2963062645/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexQ_45bEeiN61bwTfmqb3GY3kq_o8GkmgV0nR5T_TMMRp_450Meta || {},
    component: () => import("/codebuild/output/src2963062645/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src2963062645/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: index4m_Whf1CL2LP8Gxa9pD5B89TgWwt0fKNJh97cZP9z6gMeta || {},
    component: () => import("/codebuild/output/src2963062645/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexpjunPW1qfIg9y5mcnNj88DCiemORFQoD_q2dHGG9XtQMeta || {},
    component: () => import("/codebuild/output/src2963062645/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]